import { Button, InfoPage } from "@shapr3d/frontend-lib";

import useNavigation from "../hooks/navigation";

export const SSOMismatchErrorPage: React.FC = () => {
  const navigation = useNavigation();

  return (
    <InfoPage
      variant="warning"
      title="Email or domain mismatch"
      description="There was a mismatch between the emails you provided. If your email address was updated, please contact your team owner for support."
      primaryCTA={<Button onClick={() => navigation.goToSignIn()}>Back to log in</Button>}
    />
  );
};
